import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

/**
 * Fires a POST /track/view whenever the route changes.
 * Uses a persistent anonymous session id from localStorage. No IP, no PII.
 * Excludes /admin routes on the backend side too.
 */
export default function useTraffic() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    let sid = "";
    try {
      sid = window.localStorage.getItem("syndafam-sid") || "";
      if (!sid) {
        sid = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2)) + "-" + Date.now().toString(36);
        window.localStorage.setItem("syndafam-sid", sid);
      }
    } catch { /* storage denied */ }
    api.post("/track/view", {
      path: loc.pathname + (loc.search || ""),
      referrer: document.referrer || "",
      session_id: sid,
    }).catch(() => { /* silent */ });
  }, [loc.pathname, loc.search]);
}
